// import { bannerList } from '../../api/banner'
// import { homeProductList } from '../../api/home'
// import { homeCategoryMenu } from '../../api/recommend'
import { articleList } from '../../api/article'
import { activityNewList, activityDetail } from '../../api/activity'
// initial state
const state = {
  // banners: null,
  activities: null,
  activitiespaged: null,
  news: null,
  newpaged: null,
  // xhtl: null,
  // hotProducts: null,
  // recentlyProducts: null,
  // goodProducts: null,
  activityInfo: null,
}

// mutations
const mutations = {
  // saveHomeBanners(state, items) {
  //   state.banners = items
  //   state.xhtl = items//信号通路
  // },
  // saveHomeProducts(state, data) {
  //   state.hotProducts = data.hot_products;//热卖
  //   state.recentlyProducts = data.recently_products;//新品
  // },
  // saveHomeMenu(state, data) {
  //   state.menus = data
  // },
  saveHomeArticleList(state, data) {
    state.news = data.articles//新闻
    state.newpaged = data.paged
  },
  saveHomeActivityList(state, data) {
    state.activities = data.activities//活动
    state.activitiespaged = data.paged
  },

  saveHomeActivityInfo(state, data) {
    state.activityInfo = data
  },
}

// actions
const actions = {
  // fetchHomeBanner({ commit, state }, params) {
  //   return new Promise((resolve, reject) => {
  //     bannerList(params.name).then(
  //       (response) => {
  //         if (response && response.banners) {
  //           //原代码 正常可用
  //           commit('saveHomeBanners', response.banners)
  //         }
  //         resolve(response)
  //       }, (error) => {
  //         reject(error)
  //       })
  //   })
  // },

  // fetchHomeProduct({ commit, state }, params) {
  //   return new Promise((resolve, reject) => {
  //     homeProductList(params.name).then(
  //       (response) => {
  //         if (response) {
  //           commit('saveHomeProducts', response)
  //         }
  //         resolve(response)
  //       }, (error) => {
  //         reject(error)
  //       })
  //   })
  // },

  // fetchHomeMenu({ commit, state }, params) {
  //   return new Promise((resolve, reject) => {
  //     homeCategoryMenu(1, 1000).then(
  //       (response) => {
  //         if (response) {
  //           commit('saveHomeMenu', response)
  //         }
  //         resolve(response)
  //       }, (error) => {
  //         reject(error)
  //       })
  //   })
  // },

  fetchHomeArticleList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      articleList(params.id, params.page, params.per_page).then(
        (response) => {
          if (response) {
            commit('saveHomeArticleList', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeActivityList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      activityNewList(params.id, params.page, params.per_page).then(
        (response) => {
          if (response) {
            commit('saveHomeActivityList', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeActivityInfo({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      activityDetail(params.id).then(
        (response) => {
          if (response) {
            commit('saveHomeActivityInfo', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js